module.exports = __webpack_public_path__ + "static/images/money-icon.fefb4de.png";